// Sitenin dış bağlantıları tek yerde: mağaza linkleri, sosyal medya, alan adı.

export const SITE_URL = 'https://sogiturkiye.com';
export const SITE_NAME = 'Şogi Türkiye';
export const CONTACT_EMAIL = 'iletisim@sogiturkiye.com';

export const PLAY_STORE_ID = 'sogi.oyna';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`;

export const CHROME_EXTENSION_ID = 'mbdeedbnkelejcccjpkaoeiiodicdoak';
export const CHROME_EXTENSION_URL = `https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}`;

export const SOCIAL = {
  youtube: 'https://www.youtube.com/@ŞogiTürkiye',
  instagram: 'https://instagram.com/sogiturkiye',
  blog: 'https://blog.sogiturkiye.com',
};

// Mağaza linklerine kaynak etiketi ekler (Play Console / analytics'te kaynağı görmek için).
export function withUtm(url, medium) {
  const sep = url.includes('?') ? '&' : '?';
  if (url.startsWith('https://play.google.com')) {
    return `${url}${sep}referrer=${encodeURIComponent(`utm_source=sogiturkiye_web&utm_medium=${medium}`)}`;
  }
  return `${url}${sep}utm_source=sogiturkiye_web&utm_medium=${medium}`;
}
